import { apiInstances } from '../../../../libs';

const { post } = apiInstances.authInstance;

export default function createRequestPassword(payload) {
  return post(`/password/restore/clouder`, payload);
}
